import React from "react";
import Chart from "react-apexcharts";
import { formatAxisTick, formatWithCommas } from "./format";

const SERIES_META = {
  input: { label: "Input tokens", color: "#2a78d6" },
  output: { label: "Output tokens", color: "#1baf7a" },
};

const TokenUsageChart = ({ data }) => {
  const categories = data.map((row) => row.month);

  const series = [
    { name: SERIES_META.input.label, data: data.map((row) => row.input) },
    { name: SERIES_META.output.label, data: data.map((row) => row.output) },
  ];

  const options = {
    chart: {
      type: "line",
      toolbar: { show: false },
      fontFamily: "inherit",
      zoom: { enabled: false },
    },
    colors: [SERIES_META.input.color, SERIES_META.output.color],
    stroke: { curve: "smooth", width: 2 },
    markers: { size: 4, strokeWidth: 0, hover: { size: 5 } },
    grid: {
      borderColor: "#eef0f2",
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
    },
    xaxis: {
      categories,
      axisBorder: { color: "#e5e7eb" },
      axisTicks: { show: false },
      labels: { style: { colors: "#8a8f98", fontSize: "12px" } },
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      tickAmount: 4,
      labels: {
        style: { colors: "#8a8f98", fontSize: "12px" },
        formatter: (value) => formatAxisTick(value),
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "center",
      markers: { width: 12, height: 3, radius: 2 },
      itemMargin: { horizontal: 12 },
      labels: { colors: "#4b5563" },
    },
    tooltip: {
      y: { formatter: (value) => formatWithCommas(value) },
    },
    dataLabels: { enabled: false },
  };

  return (
    <div className="viz-root">
      <Chart options={options} series={series} type="line" height={360} />
    </div>
  );
};

export default TokenUsageChart;
